import { defineComponent, ref } from 'vue'

import { BucketAPIHelper } from '@/lib/BucketAPIHelper'

export default defineComponent({
    name: 'AuthenticationPage',
    setup () {
        const password = ref('')
        const showSnackbar = ref(false)
        const snackbarColor = ref('error')
        const snackbarMessage = ref('')

        return {
            password,
            showSnackbar,
            snackbarColor,
            snackbarMessage
        }
    },
    methods: {
        login () {
            if (this.password.trim() === '') return this.notify('Password cannot be empty.', 'error')

            BucketAPIHelper.login(this.password)
                .then(() => {
                    window.location.href = '/'
                    this.notify('Login successful!', 'success')
                })
                .catch(err => {
                    if (err.response && err.response.status === 401) {
                        this.notify('Unauthorized access. Please check your password.', 'error')
                    } else {
                        this.notify(err, 'error')
                    }
                })
        },
        notify (message: string, color: string) {
            this.showSnackbar = true
            this.snackbarColor = color
            this.snackbarMessage = message
        }
    }
})